import { createIntl, createIntlCache } from 'react-intl'
import { notification } from 'antd'
import moment from 'moment'

import { canRedirectToLogin, redirectToLogin } from './session'
import { locale, messages } from './translations'

const intl = createIntl({ locale, messages }, createIntlCache())

export const handleServerError = error => {
  console.error(error)
  if (error.response?.status === 401 && canRedirectToLogin()) {
    redirectToLogin()
  } else {
    const status = error.response?.status
    const data = error.response?.data
    return notification.error({
      message: status
        ? intl.formatMessage({ id: 'error.title.specific' }, { statusCode: status })
        : intl.formatMessage({ id: 'error.title.generic' }),
      description: data?.message || intl.formatMessage({ id: 'error.description.generic' })
    })
  }
}

export const formatDateTime = (date, format) =>
  moment(date).format(format || 'HH:mm')

export const getShortName = (firstName, lastName) =>
  `${firstName} ${lastName.substring(0, 1)}.`

const capitalize = word => word.charAt(0).toUpperCase() + word.slice(1)

// Corporate addresses are name.surname@domain. Returns null when the organizer is a calendar
// resource instead of a person, so the caller can fall back to a generic message.
export const emailToName = email => {
  const address = String(email || '')
  const at = address.lastIndexOf('@')
  if (!address) return null
  if (at < 0) return address

  // Match on the domain, not anywhere in the address: room resources and group calendars
  // live under .calendar.google.com and are not people.
  if (address.slice(at + 1).endsWith('.calendar.google.com')) return null

  const local = address.slice(0, at)
  if (!local.includes('.')) return address
  return local
    .split('.')
    .map(part => part.split('-').map(capitalize).join('-'))
    .join(' ')
}
